import { Component } from "solid-js";
import { BemModifiers } from "./types";
import { bem } from 'classnames-bem';

export const Divider: Component<BemModifiers> = (props) => (
    <div class={bem("b-divider", props.modifiers)} />
)